import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

/**
 * Send order FCM notification via Firebase Cloud Function
 * @param {string} orderId - The order ID
 * @param {string} date - Order date (e.g. "2026-7-26" or "2026-07-26")
 * @param {string} language - "hr" or "en"
 * @param {string} env - "superpajo" or "test"
 * @returns {Promise<Object>} Response from cloud function
 */
export const sendOrderNotification = async (
  orderId,
  date,
  language = "hr",
  env,
) => {
  try {
    const functions = getFunctions(app);
    const sendFCMNotificationFunction = httpsCallable(
      functions,
      "sendFCMDeliveryStarted",
    );

    const result = await sendFCMNotificationFunction({
      orderId,
      date,
      language,
      env,
    });

    console.log("FCM notification call success:", result.data);
    return result.data;
  } catch (error) {
    console.error("Error sending FCM notification:", error);
    throw error;
  }
};
